import RouteError from '../../../routing/RouteError';
import Switch from '../../../routing/Switch';

export default function SwitchErrorRoute({ children }) {
    return (
        <Switch>
            {children}
            <RouteError errorCode={404} />
        </Switch>
    );
}
